import type { ToastState } from './types'

export const defaultValues: ToastState = {
  toasts: [],
}
